import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { JVDate } from "../../shared/JVDate";
import { JVDropdown } from "../../shared/JVDropdown";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { IPaperWork } from "../../models/IPaperwork";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useRef, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { IDocumentMastDropdown } from "../../models/IDropdown";
import { Toast } from "primereact/toast";
import { IPurchaseOrder } from "../../models/PurchaseOrder";

interface IProps {
    po: IPurchaseOrder,
    paperWork: IPaperWork,
    reloadData: () => void
}

const schema = yup.object({
    document_Type: yup.string().required("Select Document Type"),
    document_Name: yup.string().required("Select Document Name").min(1, "Select Document Name"),
    // expiration_Date: yup.date().required("Expiration Date is required").typeError("Expiration Date is required"),
});

export const PODocType = [
    { name: "Consultant" },
    // { name: "Vendor" },
    // { name: "Client" },
];

export const UpoladDocument = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [paperWork, setPaperWork] = useState<IPaperWork>({ document_Type: "Consultant" });
    const [documents, setDocuments] = useState<Array<IDocumentMastDropdown>>();
    const [documentsList, setDocumentsList] = useState<{
        consultant_documents: Array<IPaperWork>,
        vendor_documents: Array<IPaperWork>,
        client_documents: Array<IPaperWork>,
    }>({ consultant_documents: [], client_documents: [], vendor_documents: [] });
    const [docFile, setDocFile] = useState<File | null | any>(null);

    const { control, handleSubmit, unregister, formState: { errors }, reset, setValue, watch } = useForm<IPaperWork>({
        resolver: yupResolver(schema),
        defaultValues: { document_Type: "Consultant" },
        shouldFocusError: false
    });
    const selectedDocument = watch("document_Name");

    const toast = useRef<any>(null);

    const loadDocuments = async (type?: string) => {
        const response = await Fetch("Dropdown/document", "GET", null, null, null);
        if (response) {
            const data: Array<IDocumentMastDropdown> = await response.json();
            const consultant: Array<IDocumentMastDropdown> = [];
            const Vendor: Array<IDocumentMastDropdown> = [];
            const Client: Array<IDocumentMastDropdown> = [];
            data.forEach((d: IDocumentMastDropdown) => {
                if (!(d.document_Name.includes("Vendor") || d.document_Name.includes("Client"))) consultant.push(d);
                // if ((d.document_Name.includes("Vendor"))) Vendor.push(d);
                // if ((d.document_Name.includes("Client"))) Client.push(d);
            });
            if (type === "Consultant") {
                setDocuments(consultant);
            }
            //  else if (type === "Vendor") {
            //     setDocuments(Vendor);
            // } else if (type === "Client") {
            //     setDocuments(Client);
            // } 
            else {
                setDocuments(consultant);
            };

        }
    }

    const fileUploade = async (event: FileUploadHandlerParam) => {
        if (event.files[0].size > 102400 * 5) {
            toast.current.show({ severity: 'error', content: "Document should be less than 5 MB." });
            event.options.clear();
        } else {
            setDocFile(event.files[0]);
            toast.current.show({ severity: 'success', content: "Document Selected." });
            event.options.clear();
        }
    }

    const loadDocumentsList = async () => {
        setLoading(true);
        const response = await Fetch("vwPODetailsExternalUser/apw", "GET", null, `po_id=${props.po.pO_ID}`, toast);
        if (response) {
            const data: {
                consultant_documents: Array<IPaperWork>,
                vendor_documents: Array<IPaperWork>,
                client_documents: Array<IPaperWork>,
            } = await response.json();
            setDocumentsList(data);
        }
        setLoading(false);
    }

    const saveDocument = async (body: IPaperWork, isDelete?: boolean) => {
        setLoading(true);
        body.pO_ID = props.po.pO_ID;
        body.consultant_ID = props.po.consultant_ID;
        body.sub_Vendor_ID = props.po.sub_Vendor_ID;
        body.prime_Vendor_ID = props.po.prime_Vendor;
        // if (isDelete) {
        //     const response = await Fetch("vwPODetails/apw", "DELETE", body, null, props.toast);
        //     if (response) {
        //         props.toast.current.show({ severity: 'success', content: `Document Deleted Successfully` });
        //         setPaperWork({ document_Type: "Consultant" });
        //         loadDocumentsList();
        //     } else setLoading(false);
        // } else {
        const method = body.document_ID ? "PUT" : "POST";
        const message = body.document_ID ? "Updated Successfully" : "Added Successfully";

        const formData = new FormData();
        formData.append("file", docFile);
        formData.append("paperWork", JSON.stringify(body));
        //formData.append('userType', `${loginObj.user_Type}`);
        //formData.append('userID', `${loginObj.user_Type === 2 ? loginObj.consultant_ID : loginObj.sub_Vendor_ID}`);
        const params = {
            method: method,
            headers: { Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`, },
            body: formData,
        };
        const response = await fetch(`${baseUrl}vwPODetailsExternalUser/apw`, params);

        // const response = await Fetch("vwPODetails/apw", method, body, null, toast);
        if (response.ok === true) {
            toast.current.show({ severity: 'success', content: `Document ${message}` });
            setPaperWork({ document_Type: "Consultant" });
            loadDocumentsList();
            reset({ document_Type: "Consultant" });
            loadDocuments();
            props.reloadData();
        } else {
            const resp = await response.text();
            toast.current.show({ severity: 'error', content: `This Document is already Exist, Please try to update` });
            setLoading(false);
        }
        // }
    }

    function onSubmit(data: any) {
        if ((typeof selectedDocument === "string" &&
            selectedDocument !== "1099" &&
            selectedDocument !== "SSN" &&
            selectedDocument !== "W2" &&
            selectedDocument !== "W4" 
            )) {
            if (data.expiration_Date == "" || data.expiration_Date == null) {
                toast.current.show({ severity: 'error', content: "please select expiration date" });

            } else {
                saveDocument(data);
            }
        } else {
            saveDocument(data);
        }

    };

    useEffect(() => { loadDocuments(); }, []);
    useEffect(() => {
        if (props.paperWork.document_ID) {
            props.paperWork.expiration_Date = new Date(props.paperWork.expiration_Date || "");
            reset(props.paperWork);
        }
    }, [props.paperWork]);

    useEffect(() => {
        if (
            selectedDocument === "1099" ||
            selectedDocument === "W2" ||
            selectedDocument === "W4" ||
            selectedDocument === "SSN"

            // (selectedDocument !== "SSN" && selectedDocument !== "W2" && selectedDocument !== "W4")
        ) {
            unregister("expiration_Date");
        }
    }, [selectedDocument, unregister]);


    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                {/* <JVDropdown required column={2} disabled={paperWork.document_ID !== undefined && paperWork.document_ID !== 0} label="Document Type" control={control} name="document_Type" error={errors.document_Type?.message} options={PODocType} optionLabel="name" optionValue="name" placeholder="Select Document Type" /> */}
                <JVDropdown required column={3} disabled={props.paperWork.document_ID !== undefined && props.paperWork.document_ID !== 0} label="Document Type" control={control} name="document_Name" error={errors.document_Name?.message} options={documents} optionLabel="document_Name" optionValue="document_Name" placeholder="Select Document Name" />
                {(
                    (typeof selectedDocument === "string" &&
                        selectedDocument !== "1099" &&
                        selectedDocument !== "SSN" &&
                        selectedDocument !== "W2" &&
                        selectedDocument !== "W4"
                    )
                ) && <JVDate column={4} label="Expiration Date" required control={control} name="expiration_Date" error={errors.expiration_Date?.message} />}
                <div className="field col-12 md:col-5 flex gap-3">
                    <div className="mt-1">
                        <label htmlFor="file">Document<span style={{ color: 'red' }}>*</span></label>
                        <FileUpload chooseLabel="Choose Document" mode="basic" name="file" accept="*" customUpload auto uploadHandler={fileUploade} />
                    </div>
                    <Button loading={loading} style={{ height: "35px", width: "100px" }} className="mt-4" label={props.paperWork?.document_ID ? "Update" : "Submit"} type="submit"></Button>
                </div>
                {/* <div className="field col-12 md:col-3">
                    <label htmlFor="">&nbsp;</label>
                </div> */}
            </form>
            <Toast ref={toast} />
        </>
    );
}